import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { subDays } from 'date-fns';
import {
    setFilterDate,
    setFilterCompare,
    setFilterDateCompare,
    setFilterTimestep,
} from 'src/context/reducers/filter-settings/filterSlice';
import { toVisibilityTimestep } from 'src/utils/visibility-timestep';

// Pages under /brand/visibility that publish their own window and must not be
// overwritten here. Same convention as `routesWithOwnDateDefaults` in the header.
// Local is one: its period and comparison come from the two toolbar dropdowns,
// and child effects run before the parent's, so without this exception the
// layout clobbers the preset right after the page published it — the grid then
// queries a window the dropdown does not show.
const ROUTES_WITH_OWN_DATE_DEFAULTS = ['/brand/visibility/local'];

export default function VisibilityLayout() {
    const dispatch = useDispatch();
    const location = useLocation();
    const pageOwnsDates = ROUTES_WITH_OWN_DATE_DEFAULTS.includes(location?.pathname);
    const timestep = useSelector((state: any) => state.filters?.timestep);

    // Visibility has no Daily (its scraping tables are weekly): a Daily inherited
    // from another module switches to Weekly on arrival. Only the granularity
    // changes — `skipAlignment` keeps the window as is, Local's presets included.
    // Declared before the defaults below so they align on the weekly granularity.
    useEffect(() => {
        const visibilityTimestep = toVisibilityTimestep(timestep);
        if (visibilityTimestep !== timestep) {
            dispatch(setFilterTimestep({ timestep: visibilityTimestep, skipAlignment: true }));
        }
    }, [dispatch, timestep]);

    useEffect(() => {
        if (pageOwnsDates) return;

        const now = new Date();
        dispatch(
            setFilterDate({
                start: subDays(now, 30).toISOString(),
                end: subDays(now, 1).toISOString(),
            })
        );
        dispatch(setFilterCompare(false));
        dispatch(
            setFilterDateCompare({
                compareStart: subDays(now, 60).toISOString(),
                compareEnd: subDays(now, 31).toISOString(),
            })
        );
    }, [dispatch, pageOwnsDates]);

    return <Outlet />;
}
